module.exports = __webpack_public_path__ + "images/emoji/globe_with_meridians.b40bb89db141defd59c6.png";